/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from 'ui-lottery/src/utils/async_utils';
import * as api from '../api/index';
import * as types from '../constants/actions';

export const fetchLocations = makeAsyncAction(
    types.FETCH_LOCATIONS,
    () => () => api.getLocations(),
    'facilities'
);
